import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Popover,
  TextField, Typography
} from '@material-ui/core';
import { CustomerNameObject } from 'common/models/customer';
import { useFormik } from 'formik';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import * as Yup from 'yup';
import { useAppSelector } from 'app';
import PersonIcon from '@mui/icons-material/Person';
import InitialsAvatar from 'components/messaging/components/initials-avatar';
import CustomerAPI from 'components/customer/api/CustomerAPI';
import AppSnackBar from 'components/snackbar/snackbar';
import { useStyles } from './CustomerForm';
import { DmsTypeEnum } from 'common/enums/DmsTypeEnum';
import FacebookIcon from '@mui/icons-material/Facebook';

export function CustomerNameComponent({
  customerNameObject, dmsTypeId, crmCustomerId, formikErrors,
  //showfacebookIcon,
   showNameFields, onFormSubmit, SetisCustomerNumberUnique,SetNameObject,
}: {
  customerNameObject: CustomerNameObject | undefined;
  dmsTypeId: number;
  crmCustomerId: number;
  formikErrors: any;
  showNameFields?: boolean;
 // showfacebookIcon?: boolean;
  onFormSubmit(customerName: CustomerNameObject): void;
  SetisCustomerNumberUnique(value: boolean): void;
  SetNameObject (customerName: CustomerNameObject): void;
}): ReactElement {
  const [showSnackBar] = AppSnackBar.useSnackBar();
  const dealerId = useAppSelector((state) => state.user.dealerId);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showError, setShowError] = useState(false)
  const [name, setName] = useState<string>('')
  const [anchorEl, setAnchorEl] = React.useState(null);
  const limit = dmsTypeId == DmsTypeEnum.Ideal? 20 : 25;
// const isRestrictedDms = [DmsTypeEnum.Infinity, DmsTypeEnum.DIS].includes(dmsTypeId);

  let initialValues: CustomerNameObject = {
    dateOfBirth: new Date(),
    customerNumber: null,
    firstName: '',
    middleName: '',
    lastName: '',
    name: '',
    jobTitle: '',
    contactId: -1,
  };
  if (customerNameObject) {
    initialValues = { ...customerNameObject };
  }
  

  const formik = useFormik({
    initialValues,
    onSubmit: (values: CustomerNameObject) => {
      const sanitizedValues = { ...values };
      onFormSubmit(sanitizedValues);
    },
  });
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const showNameValidation = () => {
      const nameMissing = dmsTypeId === 1 && !formik.values.name;
      const firstOrLastNameMissing = dmsTypeId !== 1 && (!formik.values.firstName && !formik.values.middleName && !formik.values.lastName);
  
    setShowError(nameMissing || firstOrLastNameMissing);
  };
  
  async function handleClose(){
    //showNameValidation();
    const customerNumber = formik.values.customerNumber || '';      
    // Only perform validation if dmsTypeId is Aspen and DIS
  if (dmsTypeId === 9 || dmsTypeId === 12) {
    // Skip if customerNumber is empty
    if (customerNumber.length === 0) {
      SetNameObject(formik.values);
      formik.handleSubmit();
      setAnchorEl(null);
      return;
    }
    if (customerNumber.length > 15) {
      formik.setFieldError('customerNumber', 'Max 15 characters allowed.');
      return; 
    }
    const isDuplicate = await checkCustomerNumberExists(customerNumber);
    if (!isDuplicate) {
      formik.setFieldError(
        'customerNumber',
        `'${customerNumber}' already in use. Please enter a unique ID or ensure the ID entered does not exceed 15 characters.`
      );
      return; 
    }
  }
    SetNameObject(formik.values);
    formik.handleSubmit();
    setAnchorEl(null);
  };  
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  async function checkCustomerNumberExists(value:any) {
    const customerNumber = value;
    if (customerNumber && customerNumber.length > 0) {
       setShowSpinner(true);
      const req = {
        crmCustomerId: crmCustomerId,
        customerNumber: customerNumber.toString(),
      };
      const customerNumberExists = await CustomerAPI.checkCustomerNumberExists(req);
      if (customerNumberExists) {
        SetisCustomerNumberUnique(false);
        setShowSpinner(false);
        return false; // Not unique
      } else {
        SetisCustomerNumberUnique(true);
        setShowSpinner(false);
        return true; // Unique
      }
    }
    return true; // Assume unique if empty
  }

  useEffect (()=> {
    let name = formik.values.firstName;
    if (formik.values.middleName) {
      name += ' ' + formik.values.middleName;
    }
    if (formik.values.lastName) {
      name += ' ' + formik.values.lastName;
    }
    // if (formik.values.customerNumber) {
    //   name += ' (' + formik.values.customerNumber + ') ';
    // }
      if (dmsTypeId === 1) {
      name = formik.values.name;
    }
    if (!name) {
      name = '';
    }

    setName(name);

  },[formik.values.firstName, formik.values.middleName, formik.values.lastName, formik.values.name])

  useEffect (() => {
      if (!showNameFields && dmsTypeId !== 1) {
        formik.setFieldValue('name', '')
        formik.setFieldValue('firstName', '')
        formik.setFieldValue('middleName', '')
        formik.setFieldValue('lastName', '')
        setName('')
      }
  },[showNameFields])
  // const name = GetCustomerName();

  const nameValidated = (sanitizedValue: string) => {
    if (dmsTypeId == DmsTypeEnum.Ideal || dmsTypeId == DmsTypeEnum.Aspen) return sanitizedValue.length <= limit;
  };

  const classes: any = useStyles();
  return (
    <>
      <Box mt={1}>
        <Grid container spacing={0}>
          <Grid item>
            <Typography variant="body1">
                          {name && (showNameFields || dmsTypeId == 1) && (
                <>
                  <InitialsAvatar
                    name={name?.replace('(', '').replace(')', '')}
                    maxInitials={2}
                    textSizeRatio={1.75}
                    size="30"
                    round
                  />{' '}
                  {name}
                  
                </>
              )}
              {(
                <>
                  <Grid container>
                                      {(!name || (!showNameFields && dmsTypeId !== 1)) &&
                    <Grid item>
                      <PersonIcon style={{ marginTop: '-2px', marginRight: '5px' }} />
                    </Grid>}
                    <Grid item>
                                          {dmsTypeId === 1 && !name || (showNameFields && !name) ? (
                      <Typography variant="h5" style={{ color: 'rgb(152 152 152)' }}>
                        Enter Customer Name
                        </Typography>) : ( !showNameFields && (dmsTypeId == 9 || dmsTypeId == 12) &&
                        <Typography variant="h5" style={{ color: 'rgb(152 152 152)' }}>
                        Enter Customer ID
                      </Typography>)
                      }
                    </Grid>
                  </Grid>
                </>
              )}
            </Typography>
          </Grid>
          <Grid item>
          {/* {showfacebookIcon?(<Box display="flex" justifyContent="flex-end" ><FacebookIcon style={{'color':'blue'}}/></Box>):null} */}
          </Grid>
          <Grid item>
            <IconButton aria-describedby={id} className={classes.iconButton} onClick={(e: any) => handleClick(e)}>
              <EditIcon style={{ fontSize: '1rem' }} />
            </IconButton>
          </Grid>
                  {(dmsTypeId !== 1 && !formik.values.firstName && (!!formikErrors.firstName || showError) || dmsTypeId !== 1 && !formik.values.lastName && (!!formikErrors.lastName || showError)) && (
            <span className={classes.errorMsg}>Customer Name Required</span>
          )}
                  {dmsTypeId === 1 && !formik.values.name && (!!formikErrors.name || showError) && <span className={classes.errorMsg}>Customer Name Required</span>}
        </Grid>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}>
        <Box p={2} style={{ width: '500px' }}>
          <Grid container justifyContent="space-between" spacing={2}>
                      {dmsTypeId === 1 && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  autoFocus
                  margin="dense"
                  id="name"
                  style={{ padding: '2px' }}
                  name="name"
                  label="Name"
                  value={formik.values.name}
                  error={!!formik.errors.name}
                  helperText={formik.errors.name}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const sanitizedValue = inputValue.trimStart(); 
                    if (sanitizedValue.length <= 30) {
                      formik.setFieldValue('name', sanitizedValue); 
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}
                      {dmsTypeId !== 1 && (
              <>
                { showNameFields && (
                  <>
                  <Grid item xs={4}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="firstName"
                    style={{ padding: '2px' }}
                    name="firstName"
                    label="First Name"
                    value={formik.values.firstName}
                    // error={!!formik.errors.firstName}
                    // helperText={formik.errors.firstName}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.trimStart(); 
                      if (nameValidated(sanitizedValue) || sanitizedValue.length < formik.values.firstName.length) {
                        formik.setFieldValue('firstName', sanitizedValue); 
                      }
                    }}                    
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    id="middleName"
                    style={{ padding: '2px' }}
                    name="middleName"
                    label="Middle Name"
                    value={formik.values.middleName}
                    // error={!!formik.errors.middleName}
                    // helperText={formik.errors.middleName}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.trimStart(); 
                      if (nameValidated(sanitizedValue) || sanitizedValue.length < formik.values.middleName.length) {
                        formik.setFieldValue('middleName', sanitizedValue); 
                      }               
                    }}                    
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                <Box display="flex" flexDirection="column" position="relative">
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    id="lastName"
                    style={{ padding: '2px' }}
                    name="lastName"
                    label="Last Name"
                    value={formik.values.lastName}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.trimStart(); 
                      if (nameValidated(sanitizedValue) || sanitizedValue.length < formik.values.lastName.length) {
                        formik.setFieldValue('lastName', sanitizedValue); 
                      }                
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                </Grid>
                </>
                )}
                <Grid item xs={8}>
                                  {(dmsTypeId === 9 || dmsTypeId === 12) && (
                    <>
                      {showSpinner ? (
                        <LinearProgress style={{ marginTop: '10px' }} />
                      ) : (
                        <TextField
                          fullWidth                
                          variant="outlined"
                          margin="dense"
                          id="CustomerId"
                          style={{ padding: '2px', marginTop: '-3px' }}
                          name="customerNumber"
                          label="Customer ID"
                          value={formik.values.customerNumber}
                          error={!!formik.errors.customerNumber}
                          helperText={formik.errors.customerNumber}   
                          onChange={(e: any) => {
                            const value = e.target.value;
                            if (value.length > 15) {
                              formik.setFieldError('customerNumber', 'Max 15 characters allowed.');
                            } else {
                              formik.setFieldValue('customerNumber', value);
                              formik.setFieldError('customerNumber', ''); // Clear error if length is valid
                            }
                          }}                       
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      )}
                    </>
                  )}
                </Grid>
              </>
            )}
            <Grid item xs={4}>
              <Button
                fullWidth
                id="saveCustomerNameBtn"
                color="primary"
                variant="contained"
                size="medium"
                onClick={() => {
                  handleClose();
                }}>
                Close
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Popover>
    </>
  );
}
